import React from 'react';

export const IconError = ({style}) => {

    return (<svg className="icon-error" style={style || {}} fill="none" height="16" viewBox="0 0 16 16" width="16"
                 xmlns="http://www.w3.org/2000/svg">
            <path
                d="m8 16c-4.416 0-8-3.584-8-8s3.584-8 8-8 8 3.584 8 8-3.584 8-8 8zm0-7.05882c.46782 0 .84706-.37924.84706-.84706v-3.48235c0-.46782-.37924-.84706-.84706-.84706-.46781 0-.84705.37924-.84705.84706v3.48235c0 .46782.37924.84706.84705.84706zm0 3.29412c.5198 0 .94118-.4214.94118-.9412s-.42138-.9412-.94118-.9412c-.51979 0-.94117.4214-.94117.9412s.42138.9412.94117.9412z"
                fill="#e64646"/>
            <path
                d="m8.00001 8.94118c.46782 0 .84706-.37924.84706-.84706v-3.48235c0-.46782-.37924-.84706-.84706-.84706-.46781 0-.84705.37924-.84705.84706v3.48235c0 .46782.37924.84706.84705.84706zm0 3.29412c.5198 0 .94118-.4214.94118-.9412s-.42138-.9412-.94118-.9412c-.51979 0-.94117.4214-.94117.9412s.42138.9412.94117.9412z"
                fill="#fff"/>
        </svg>
    )
}